import { Injectable } from '@angular/core';
import { BaseService } from '@core/service/base.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

@Injectable({providedIn: 'root'})
export class msgSettingsCenterService extends BaseService {
  getUrl(): string {
    return "api/msgSettings";
  }

  constructor(http: HttpClient) {
    super(http);
  }

/*  /!** GET by id. Will 404 if id not found *!/
  get2(id:number):Observable<any> {
    const url = `${this.getUrl()}/${id}/2`;
    return this.http.get<any>(url).pipe(
      tap(_ => this.log(`fetched object id=${id}`)),
      catchError(this.handleError<any>(`getany id=${id}`))
    );
  }*/
}
